import { useEffect } from "react";

export const IMAGES = {
  seattle:
    "https://images.unsplash.com/photo-1589481169991-40ee02888551?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxzZWF0dGxlJTIwc2t5bGluZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODcyMDg0NDV8MA&ixlib=rb-4.1.0&q=85",
  accountants:
    "https://images.pexels.com/photos/6779567/pexels-photo-6779567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  calculator:
    "https://images.pexels.com/photos/13156204/pexels-photo-13156204.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  office:
    "https://images.unsplash.com/photo-1493934558415-9d19f0b2b4d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtaW5pbWFsJTIwb2ZmaWNlfGVufDB8fHx8MTc4NzIwODQ0NXww&ixlib=rb-4.1.0&q=85",
};

// Placeholder business details — swap with the real ones anytime.
export const CONTACT = {
  phone: "(206) 451-1152",
  email: "info@calcorsolutions.com",
  location: "Seattle, Washington",
  hours: "Monday to Friday, 9:00 AM - 5:00 PM PT",
};

// Placeholder links — replace with the firm's real scheduler + portal URLs.
// Scheduler: paste the Calendly event link (e.g. https://calendly.com/calcor-solutions/consultation).
// The Contact page embed activates automatically once a real calendly.com URL is set here.
export const SCHEDULER_URL = "https://calendly.com/seattle1218/consultation";
export const PORTAL_URL = "https://app.financial-cents.com/client-portal/";

export const isRealSchedulerUrl = (value) => {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    return (
      url.protocol === "https:" &&
      (host === "calendly.com" || host.endsWith(".calendly.com")) &&
      url.pathname.length > 1 &&
      !value.includes("YOUR_") &&
      !value.includes("PLACEHOLDER")
    );
  } catch {
    return false;
  }
};

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
